var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_4920)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.00039,
    cy: 7.69998,
    r: 5.6,
    fill: "#FEFFBC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46693 6.6192V4.2C7.46693 3.9424 7.25833 3.73333 7.00026 3.73333C6.74219 3.73333 6.53359 3.9424 6.53359 4.2V6.6192C5.99133 6.81193 5.60026 7.32433 5.60026 7.93333C5.60026 8.7066 6.22699 9.33333 7.00026 9.33333C7.77353 9.33333 8.40026 8.7066 8.40026 7.93333C8.40026 7.32433 8.00919 6.81193 7.46693 6.6192ZM7.00026 13.0667C4.16526 13.0667 1.86693 10.7683 1.86693 7.93333C1.86693 5.09833 4.16526 2.8 7.00026 2.8C9.83526 2.8 12.1336 5.09833 12.1336 7.93333C12.1336 10.7683 9.83526 13.0667 7.00026 13.0667ZM7.46226 1.88999C7.46272 1.88159 7.46693 1.87507 7.46693 1.86667V0.933333H9.33359C9.59166 0.933333 9.80026 0.724733 9.80026 0.466667C9.80026 0.2086 9.59166 0 9.33359 0H4.66693C4.40886 0 4.20026 0.2086 4.20026 0.466667C4.20026 0.724733 4.40886 0.933333 4.66693 0.933333H6.53359V1.86667C6.53359 1.87507 6.5378 1.88159 6.53826 1.88999C3.4046 2.12706 0.933594 4.73853 0.933594 7.93333C0.933594 11.284 3.64959 14 7.00026 14C10.3509 14 13.0669 11.284 13.0669 7.93333C13.0669 4.73853 10.5959 2.12706 7.46226 1.88999Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_4920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.dd28db730e6113e737f4f338d96ca2c9.svg";
export { ForwardRef as ReactComponent };